import { getAll } from '../api/customer'
import * as types from './types';

const request = () => {
  return {
    type: types.REQUEST,
    payload: true,
  }
}

const success = customers => {
  return {
    type: types.SUCCESS,
    payload: customers,
  }
}

const change = customer => {
  return {
    type: types.UPDATE,
    payload: customer,
  }
}

const error = error => {
  return {
    type: types.ERROR,
    payload: error,
  }
}

const loadCustomers = params => {  
  return dispatch => {
    dispatch(request());    
    getAll(params)
      .then(res => {
        dispatch(success(res.data));
    }).catch(e => {
      dispatch(error(e))
    });
  }
};

const updateCustomer = customer => {
  return dispatch => { 
    dispatch(change(customer))
  }
}
 
export {
  loadCustomers,
  updateCustomer,
  success,
  request,
  error
};



// WEBPACK FOOTER //
// ./src/store/customers/action.js